export interface NavData {
    name?: string;
    url?: string;
    icon?: string;
    image?: string;
    divider?: boolean;
    children?: NavData[];
}

export const navItems: NavData[] = [
    {
        name: 'siderbar.dashboard',
        url: '/dashboard',
        icon: '',
        image: 'icondashboard.svg',
    },
    {
        name: 'siderbar.mapinfo',
        url: '/info',
        icon: '',
        image: 'worldwide.svg',
    },
    // {
    //   name: "siderbar.associations",
    //   url: "",
    //   icon: "star",
    //   image: "iconhiephoi.svg",
    //   children: [
    //     {
    //       name: "siderbar.associations",
    //       url: "/associations",
    //       icon: "",
    //     },
    //   ],
    // },
    {
        name: 'siderbar.userPartner',
        url: '',
        icon: 'star',
        image: 'leadership.svg',
        children: [
            // {
            //     name: 'siderbar.agronomist',
            //     url: '/agronomists',
            //     icon: '',
            // },
            {
                name: 'siderbar.fermenter',
                url: '/fermenters',
                icon: '',
            },
            {
                name: 'siderbar.sourcing',
                url: '/sources',
                icon: '',
            },
            {
                name: 'siderbar.agronomist',
                url: '/agronomists',
                icon: '',
            },
            {
                name: 'siderbar.farmers',
                url: '/farmers',
                icon: '',
            },

        ],
    },
    {
        name: 'siderbar.erp',
        url: '',
        icon: 'star',
        image: 'erp.svg',
        children: [
            {
                name: 'siderbar.vendor',
                url: '/vendors/vendor-list',
                icon: '',
            },
            {
                name: 'siderbar.item',
                url: '/vendors/item-list',
                icon: '',
            }
        ]
    },
    {
        name: 'siderbar.agronomist',
        url: '',
        icon: 'star',
        image: 'agronomist.svg',
        children: [
            {
                name: 'siderbar.farmSeason',
                url: '/farm-season/flows',
                icon: '',
            },

            {
                name: 'siderbar.survey',
                url: '/survey',
                icon: '',
            },
            {
                name: 'siderbar.survey-result-and-analysis',
                url: '/surveyResultAndAnalysis',
                icon: '',
            },
        ],
    },
    {
        name: 'siderbar.process',
        url: '/process/flows',
        icon: '',
        image: 'efficiency.svg',
    },
    {
        name: 'siderbar.sourcing-process',
        url: '',
        icon: 'star',
        image: 'process.svg',
        children: [
            {
                name: 'siderbar.plan',
                url: '/plan',
                icon: '',
            },
            {
                name: 'siderbar.product-register',
                url: '/cates/list',
                icon: '',
            },
            {
                name: 'siderbar.rating',
                url: '/rating/list',
                icon: '',
            },
            {
                name: 'siderbar.scale',
                url: '/scale/list',
                icon: '',
            },
        ],
    },
    {
        name: 'siderbar.products',
        url: '',
        icon: 'star',
        image: 'coffee-breaks.svg',
        children: [
            {
                name: 'siderbar.product-curde',
                url: '/products/product-curde',
                icon: '',
            },
            {
                name: 'Contract.title',
                url: '/contracts',
                icon: '',
            },
            {
                name: 'siderbar.package-infos',
                url: '/products/package-infos',
                icon: '',
            },
            {
                name: 'siderbar.product',
                url: '/products/products',
                icon: '',
            },
        ],
    },
    // {
    //     name: 'siderbar.event',
    //     url: '',
    //     icon: 'star',
    //     image: 'iconaccount.svg',
    //     children: [
    //
    //     ],
    // },
    {
        name: 'siderbar.other',
        url: '',
        icon: 'star',
        image: 'portfolio.svg',
        children: [
            {
                name: 'siderbar.news',
                url: '/news',
                icon: '',
            },
            {
                name: 'siderbar.fertilizer-medicines',
                url: '/fertilizer-medicines',
                icon: '',
            },
            {
                name: 'siderbar.problem',
                url: '/problem',
                icon: '',
            },
            {
                name: 'siderbar.event',
                url: '/events',
                icon: '',
            }
        ],
    },
    {
        name: 'siderbar.reports',
        url: '',
        icon: 'star',
        image: 'portfolio.svg',
        children: [
            {
                name: 'Report.fermentationReport',
                url: '/report-fermentation',
                icon: '',
            },
            {
                name: 'Report.materialReport',
                url: '/report-material',
                icon: '',
            },
            {
                name: 'Report.contractReport',
                url: '/report-trace-contract',
                icon: '',
            },
            {
                name: 'Report.farmReport',
                url: '/report-farm',
                icon: '',
            },
            {
                name: 'Report.farmerReport',
                url: '/report-farmer',
                icon: '',
            },
        ],
    },
];

export const navHeaderLeft: NavData[] = [
    {
        name: 'headerleft.menu1',
        url: '',
        icon: '',
    },
    {
        name: 'headerleft.menu2',
        url: '',
        icon: '',
    },
    {
        name: 'headerleft.menu3',
        url: '',
        icon: '',
    },
];

export const navHeaderUser: NavData[] = [
    {
        name: 'headeruser.systems',
        url: '',
        icon: '',
    },
    {
        name: 'headeruser.profile',
        url: '',
        icon: '',
    },
    {
        divider: true,
    },
    {
        name: 'headeruser.logout',
        url: '',
        icon: '',
    },
];
